import {
  Box,
  Breadcrumbs,
  Card,
  Checkbox,
  FormControlLabel,
  IconButton,
  Stack,
  Switch,
  Tooltip,
  Typography,
  CircularProgress,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import Pagination from "@mui/material/Pagination";
import JumboListNoDataPlaceHolder from "@jumbo/components/JumboList/components/JumboListNoDataPlaceHolder";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getClients } from "app/services/api/management";

import EmployeesListItem from "./EmployeesListItem";
import JumboSearch from "@jumbo/components/JumboSearch";
const ITEM_PER_PAGE = 10;
const ClientEmployeesList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [client, setClient] = useState(null);
  const [employees, setEmployees] = useState([]);
  const { clientId } = useParams();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchName, setSearchName] = useState();
  const [onlyActive, setOnlyActive] = useState(true);
  useEffect(() => {
    const fetchClient = async () => {
      setLoading(true);
      const response = await getClients(clientId);
      const employees = response?.employees || [];
      if (searchName) {
        const filteredEmployees = employees.filter(
          (employee) =>
            employee.firstName
              .toLowerCase()
              .includes(searchName.toLowerCase()) ||
            employee.lastName
              .toLowerCase()
              .includes(searchName.toLowerCase()) ||
            employee.email.toLowerCase().includes(searchName.toLowerCase()) ||
            employee.phone.toLowerCase().includes(searchName.toLowerCase())
        );
        setClient(response);
        setEmployees(filteredEmployees || []);
      } else {
        if (onlyActive) {
          const filteredEmployees = employees.filter(
            (employee) => employee.active === onlyActive
          );
          setEmployees(filteredEmployees || []);
        } else {
          setEmployees(employees || []);
        }
      }
      setClient(response);
      setLoading(false);
    };
    fetchClient();
  }, [clientId, searchName, onlyActive]);
  const companyName = client?.companyName;
  return (
    <>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
        <Link to="/">{t("sidebar.menuItem.home")}</Link>
        <Link to="/customer/dsok/clients">
          {t("pages.dsokDetails.clients.title")}
        </Link>
        <Link to={`/customer/dsok/clients/${clientId}`}>{companyName}</Link>
        <Typography color="text.primary">
          {t("pages.dsokCustomers.employees.title")}
        </Typography>
      </Breadcrumbs>
      <React.Fragment>
        <Stack
          direction="row"
          display="flex"
          alignItems="center"
          justifyContent={"space-between"}
          mb={2}
          spacing={1}
        >
          <Box width="40%" display="flex" flexDirection="row" gap={1}>
            <Card sx={{ mb: 0, width: "100%" }}>
              <JumboSearch
                page="employees"
                onChange={setSearchName}
                sx={{
                  width: "100%",
                }}
                placeholder={t("pages.presentation.searchPresentation")}
              />
            </Card>
            <Tooltip title={t("pages.dsokCustomers.employees.add")}>
              <IconButton
                onClick={() =>
                  navigate(`/customer/dsok/clients/${clientId}/employees/new`)
                }
              >
                <AddBoxIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <Box display="flex" alignItems="left" mb={2} ml={2}>
            <FormControlLabel
              labelPlacement="start"
              control={
                <Switch
                  checked={onlyActive}
                  onChange={(event) => setOnlyActive(event.target.checked)}
                  name="onlyActive"
                  color="primary"
                />
              }
              label={t("pages.dsokCustomers.employees.onlyActive")}
              sx={{
                ml: 2,
                fontSize: "12px",
              }}
            />
          </Box>
          <Pagination
            count={Math.ceil(employees?.length / ITEM_PER_PAGE)}
            color="primary"
            page={page}
            onChange={(_, val) => setPage(val)}
          />
        </Stack>
        {loading ? (
          <CircularProgress sx={{ m: "5px 50%" }} />
        ) : (
          <>
            {employees?.length ? (
              employees.map((client, index) =>
                index + 1 > ITEM_PER_PAGE * (page - 1) &&
                index + 1 <= ITEM_PER_PAGE * page ? (
                  <EmployeesListItem
                    key={index}
                    item={client}
                    disabled={loading}
                  />
                ) : null
              )
            ) : (
              <JumboListNoDataPlaceHolder />
            )}
          </>
        )}
      </React.Fragment>
    </>
  );
};

export default ClientEmployeesList;
